
import React, { createContext, useEffect, useState, useContext } from 'react';
import { saveDataSet, getDataSet } from '../services/data';
import { AppContext } from './AppContext';
import {
  getFullTimeZone,
} from "../utils/utils";

const DataSetsContext = createContext();

export const DataSetsProvider = ({ children }) => {
  const [dataSets, setDataSets] = useState([]);
  const [selectedDataSet, setSelectedDataSet] = useState(null);
  const [updatedDataSet, setUpdatedDataSet] = useState(null);

  const { selectedClient } = useContext(AppContext);
  console.log("!!! SELECTED CLIENT IN data SETS CONTEXT: ", selectedClient);

  useEffect(() => {
    console.log("!!! UPDATED data SET CHANGED: ", updatedDataSet);
  }, [updatedDataSet]);

  const addDataSet = (dataSet) => {
    setDataSets([...dataSets, dataSet]);
  };

  const removeDataSet = (dataSetId) => {
    setDataSets(dataSets.filter(dataSet => dataSet.id !== dataSetId));
  };

  const saveUpdatedDataSet = async () => {
    console.log("!!! SAVE UPDATED data SET CALLED: ", updatedDataSet);


    updatedDataSet.published = updatedDataSet.published ?? false;
    updatedDataSet.timezone = getFullTimeZone()
    updatedDataSet.open_date = updatedDataSet.local_open_date;
    updatedDataSet.start_date = updatedDataSet.local_start_date;
    updatedDataSet.recording_date = updatedDataSet.local_recording_date;

    const newDataSet = !updatedDataSet.public_id;

    const dataSet = await saveDataSet(updatedDataSet, selectedClient.id);
    if (dataSet) {
      if (newDataSet) {
        const fetchedDataSet = await getDataSet(dataSet.public_id, true);
        setSelectedDataSet(fetchedDataSet);
        setUpdatedDataSet(fetchedDataSet);
      }

      return dataSet.public_id;
    }
  }

  function shallowDiff(obj1, obj2) {
    const diff = {};

    if (obj1 == null) {
      for (const key in obj2) {
        diff[key] = {
          from: null,
          to: obj2[key]
        };
      }
      return diff;
    } else if (obj2 == null) {
      for (const key in obj1) {
        diff[key] = {
          from: obj1[key],
          to: null
        };
      }
      return diff;
    }


    const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    for (const key of allKeys) {
      if (obj1[key] !== obj2[key]) {
        diff[key] = {
          from: obj1[key],
          to: obj2[key]
        };
      }
    }

    return diff;
  }

  const canSaveDataSet = () => {
    if (!updatedDataSet || !updatedDataSet.title) return false;


    // Remove image_data, local_open_date, local_recording_date, and local_start_date from the comparison since they are not part of the actual dataset object and are only used for handling date inputs
    console.log("!!! SHALLOW DIFF: ", shallowDiff(selectedDataSet, updatedDataSet));


    return JSON.stringify(selectedDataSet) !== JSON.stringify(updatedDataSet);
  }

  return (
    <DataSetsContext.Provider value={{ dataSets, setDataSets, selectedDataSet, setSelectedDataSet, addDataSet, removeDataSet, updatedDataSet, setUpdatedDataSet, canSaveDataSet, saveUpdatedDataSet }}>
      {children}
    </DataSetsContext.Provider>
  );
}

export const useDataSets = () => {
  return useContext(DataSetsContext);
}

export default DataSetsContext;
